module.exports = __webpack_public_path__ + "media/images/tutorial_body_pc3-04-f5470c410fd424e552eed4ba47e2d35a.png";